module.exports = __webpack_public_path__ + "img/img_sub_ser_Integration02.efa67ac9.svg";